import VueI18n from "vue-i18n"
import Vue from "vue"
import zh from "./zh.json"
import ft from "./ft.json"
import en from "./en.json"
import es from "./es.json"
import esp from "./es.json"
import jp from "./jp.json"
import fr from "./fr.json"
import vi from "./vi.json"
import kr from "./kr.json"
import eu from "./eu.json"
import de from "./de.json"
import th from "./th.json"



Vue.use(VueI18n)

export default new VueI18n({
  locale: localStorage.getItem("language") || "zh", // 从localStorage中获取 默认英文
  messages: {
    zh,
    ft,
    en,
    es,
    esp,
    jp,
    fr,
    vi,
    kr,
    eu,
    de,
    th
  },
})
